import React, { FC } from "react";
import RelationInput from "src/components/atoms/inputs/RelationInput";
import { TemplateId, WhereItems } from "src/globalTypes";
import { RowKey } from "src/requests/table/types";
import {
  EditRowWithColumns,
  TableRowValueDict,
} from "src/requests/tableRowActions/types";
import useRelationTableData from "./useRelationTableRowData";
import useRunAfterOnchangeFinish from "./useRunAfterOnChangeFinish";

interface Props {
  name?: string;
  value: number | string | null;
  templateId: number;
  disabled: boolean;
  onChange: (newValue: string | number | null) => void;
  required: boolean;
  callbackAfterOnChangeFinish(): void; // Stane se až po propsání state hodnoty
  rowValues?: TableRowValueDict;
  detailTemplateId?: TemplateId | null;
  filter?: WhereItems;
  rowKey?: RowKey;
}
const SingleValueRelation: FC<Props> = ({
  onChange,
  callbackAfterOnChangeFinish,
  ...rest
}) => {
  const { value, templateId, disabled, name } = rest;

  const { tableRowData, isLoading, setTableRowData } = useRelationTableData(
    value,
    templateId
  );

  const MUST_RUN_THIS_ON_CHANGE = useRunAfterOnchangeFinish(
    callbackAfterOnChangeFinish,
    value,
    [name, templateId, disabled]
  );

  const handleRelationSelect = (tableRow: EditRowWithColumns): void => {
    onChange(tableRow?.row?.keyValue ?? 0);
    setTableRowData(tableRow);
    MUST_RUN_THIS_ON_CHANGE();
  };

  const handleClearInput = (e: React.MouseEvent<Element>): void => {
    e.stopPropagation();
    setTableRowData({} as EditRowWithColumns);
    onChange(null);
  };

  return (
    <RelationInput
      tableRowData={tableRowData}
      isLoading={isLoading}
      handleRelationSelect={handleRelationSelect}
      handleClearInput={handleClearInput}
      autoCloseOnSelect
      {...rest}
    />
  );
};

export default SingleValueRelation;
